
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[communityPath]/join",
      function () {
        return require("private-next-pages/community/[communityPath]/join.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[communityPath]/join"])
      });
    }
  